import styled from "styled-components";

export const LoadingTutorialWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 640px;
  min-height: 200px;
  overflow: hidden;
  padding: 1.25rem;
  background: ${({ theme }) => theme.background};
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.inputBorder};

  // Scale down tutorial view to fit
  transform: scale(0.75);
  transform-origin: 50% 100%;

  @media (max-height: 640px) {
    padding: 1rem;
    min-height: 150px;
    max-width: 480px;
  }

`;

export const LoadingTutorialBgStyled = styled.div`
    position: absolute;
    top: 1rem;
    right: ${({ rightOffset }) => rightOffset ? rightOffset : '5rem'};
    z-index: 0;
    border-radius: 50%;
    display: inline-block;

    img {
      border-radius: 50%;
      display: block;
      border:1px solid #fff;
    }

    &:after {
      content: "";
      display: block;
      width: 105%;
      height: 105%;
      background: radial-gradient(ellipse at center, rgba(18,31,170,0) 0%,rgba(18,31,170,1) 65%,rgba(18,31,170,1) 100%);
      border-radius: 50%;
      position: absolute;
      top: -2.5%; left: -2.5%;
    }
`;